@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

// TODO: Clean-up 'width: calc(100% - 48px)'. This is used becaues the app header is wider than the screen in mobile.
// Once the header solution is communicated by design this can be addressed.

.mobile-notification {
  position: fixed;
  top: 115px;
  font-size: 14px;
  left: 0;
  width: calc(100vw - 48px);
  max-width: 599px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 24px;
  padding: 12px 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  color: @notification--mobile-body--text-color;

  .mobile-notification-content {
    flex-grow: 1;
    font-size: 14px;
    line-height: 20px;
  }

  &.success {
    background-color: @notification--mobile-success-body--background-color;
  }

  .icon {
    height: auto;
    width: 16px;
    min-width: 16px;
    padding: 2px;
    border-radius: 50%;
    margin-right: 8px;
    top: 0;
    background-color: @notification--mobile-body--fill-color;
    color: @notification--mobile-success-body--background-color;
  }
}
